import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { DocumentMetasV } from "@/types/document";

export async function fetchAvailableDocuments({
  search = ""
}: {
  search?: string;
}) {
  return makeWordPressAjaxRequest({
    action: "breakdance_get_available_documents_with_search",
    dataToPost: {
      search
    },
    decoder: DocumentMetasV,
    resultKey: "data"
  });
}
